import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=3a59a2f4"
import script from "./distribution.vue?vue&type=script&lang=js"
export * from "./distribution.vue?vue&type=script&lang=js"
import style0 from "./distribution.vue?vue&type=style&index=0&id=3a59a2f4&prod&lang=scss"
import style1 from "./distribution.vue?vue&type=style&index=1&id=3a59a2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports